import React from "react"
import { useTranslation } from "react-i18next"

import { Action, ActionGroup } from "shared/types/Action"
import { ActionsOverlay } from "shared/ui/actions-overlay/ActionsOverlay"

export interface ProjectActionsOverlayViewModel {
  actions: (Action | ActionGroup)[]
  onCancel: () => void
}

export const ProjectActionsOverlayView = React.memo(
  ({ actions, onCancel }: ProjectActionsOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ActionsOverlay
        id="project-actions-overlay"
        className="project-actions-overlay"
        headline={t("Project.Actions.Actions")}
        actions={actions}
        onCancel={onCancel}
      />
    )
  }
)
